import { useLabelVersion } from '../../../../features/labels/LabelsProvider';
import { labelCentro } from '../../../../features/labels/labels';
import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import DashboardCard from './components/DashboardCard';
import { getCenters, getDataByCenter } from '../../services/api';
import './Dashboard.css';

const Dashboard = ({ servidor, translate }) => {
  useLabelVersion();
  const [dataByCenter, setDataByCenter] = useState({});
  const [visibleByCenter, setVisibleByCenter] = useState({});
  const [loading, setLoading] = useState(true);

  /* =========================
     DATA
     ========================= */
  useEffect(() => {
    let intervalId;
    let isFetching = false;

    const fetchDashboardData = async (initial = false) => {
      if (isFetching) return;
      isFetching = true;
      if (initial) setLoading(true);

      try {
        const centers = await getCenters(servidor);
        if (!centers?.length) return;

        const mappedData = {};
        const mappedVisibility = {};

        await Promise.all(
          centers.map(async (centerCode) => {
            const code = centerCode.toUpperCase();
            const data = await getDataByCenter(servidor, code);

            mappedData[code] = {
              codigo: code,
              nombre: code,
              data,
            };

            mappedVisibility[code] = {
              cumulant: true,
              flow_rate: true,
            };
          })
        );

        setDataByCenter(mappedData);
        setVisibleByCenter(mappedVisibility);
      } catch (e) {
        console.error(e);
      } finally {
        if (initial) setLoading(false);
        isFetching = false;
      }
    };

    fetchDashboardData(true);
    intervalId = setInterval(() => fetchDashboardData(false), 60_000);
    return () => clearInterval(intervalId);
  }, [servidor]);

  /* =========================
     TOGGLE
     ========================= */
  const toggleDataset = (centerCode, key) => {
    setVisibleByCenter((prev) => ({
      ...prev,
      [centerCode]: {
        ...prev[centerCode],
        [key]: !prev[centerCode][key],
      },
    }));
  };

  /* =========================
     LOADING
     ========================= */
  if (loading) {
    return (
      <div className="loading-container">
        <CircularProgress />
      </div>
    );
  }

  /* =========================
     RENDER
     ========================= */
  return (
    <div className="dashboard-container">
      <div className="dashboard-grid">
        {Object.values(dataByCenter).map(({ codigo, nombre, data }) => (
          <DashboardCard
            key={codigo}
            title={labelCentro({ region: "flux", area: "barcos", centro: codigo }, nombre)}
            centerCode={codigo}
            data={data}
            visible={visibleByCenter[codigo]}
            onToggle={toggleDataset}
            translate={translate}
          />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
